import { useQuery } from '@tanstack/react-query'
import useAuth from '@/features/auth/hooks/use-auth'
import { queryKeys } from '@/shared/constants/query-keys'
import { rolesAdminV2Service } from '../services/roles-admin-v2.service'

/**
 * Roles activos (`{ id: rol_, name }`) para el form de usuarios v2 y el filtro
 * por rol. Sólo corre con sesión staff v2; los datos casi no cambian, así que se
 * cachean largo.
 */
export const useRolesV2LookupQuery = () => {
  const { auth } = useAuth()
  const accessToken = auth?.v2AccessToken ?? ''
  return useQuery({
    queryKey: queryKeys.roles.lookupV2(),
    queryFn: async () => await rolesAdminV2Service.lookup(accessToken),
    enabled: Boolean(accessToken),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })
}
